import { adminBlacklistRoutes } from '~/router/routes/car/admin/blacklist'
import { adminCategoriesRoutes } from '~/router/routes/car/admin/categories'
import { adminPopularityRoutes } from '~/router/routes/car/admin/popularity'
import { adminSearchRoutes } from '~/router/routes/car/admin/search'
import { adminSearchLogsRoutes } from '~/router/routes/car/admin/logs'
import { adminMissingMakeModelsRoutes } from './missing-makemodels'
import adminSearchEmailsRoutes from '~/router/routes/car/admin/emails'
import { adminUserTransferClassifiedsRoute } from '~/router/routes/car/admin/transfer-classifieds'

export default [
  ...adminBlacklistRoutes,
  ...adminCategoriesRoutes,
  ...adminPopularityRoutes,
  ...adminSearchRoutes,
  ...adminSearchLogsRoutes,
  ...adminMissingMakeModelsRoutes,
  ...adminSearchEmailsRoutes,
  ...adminUserTransferClassifiedsRoute
]
